import {
  clearMessages,
  loadMessages,
  loadMessagesError,
  loadMessagesSuccess,
  setMessagesList,
  setSpam,
  setSpamError,
  setSpamSuccess,
  viewMessage,
  viewMessageError,
  viewMessageSuccess,
} from '../actions/message.action';
import { Action, createReducer, on } from '@ngrx/store';
import { EMessageState, EMessageStateStatus, IMessageState } from '../models/message.model';

const initalState: IMessageState = {
  list: null,
  status: EMessageStateStatus.INITIALIZING,
  state: null,
};

const messagesReducer = createReducer(
  initalState,
  on(loadMessages, state => {
    return {
      ...state,
      status: EMessageStateStatus.LOADING,
      state: EMessageState.LIST,
    };
  }),
  on(setMessagesList, (state, { list }) => {
    return {
      ...state,
      ids: list,
    };
  }),
  on(loadMessagesSuccess, (state, { messages, has_extra_row }) => {
    return {
      ...state,
      status: EMessageStateStatus.READY,
      list: messages,
      has_extra_row,
    };
  }),
  on(loadMessagesError, (state, { error }) => {
    return {
      ...state,
      status: EMessageStateStatus.ERROR,
      error,
    };
  }),
  on(viewMessage, (state, { id_message }) => {
    let prevMessageId = null;
    let nextMessageId = null;
    const lockedBy = null;
    if (!state.ids || state.ids.length === 0) {
      if (state.list && state.list.length > 0) {
        const currentMessageItem = state.list.filter(
          item => item.message_id === id_message,
        );

        if (currentMessageItem && currentMessageItem.length === 1) {
          const targetIndex = state.list.indexOf(currentMessageItem[0]);

          if (
            targetIndex >= 0 &&
            targetIndex < state.list.length - 1
          ) {
            nextMessageId =
              state.list[targetIndex + 1]
                .message_id;
          }
          if (targetIndex >= 1) {
            prevMessageId =
              state.list[targetIndex - 1]
                .message_id;
          }
        }
      }
    } else if (state.ids && state.ids.length > 0) {
      const targetIndex = state.ids.indexOf(id_message);

      if (targetIndex > -1) {
        if (
          targetIndex >= 0 &&
          targetIndex < state.ids.length - 1
        ) {
          nextMessageId = state.ids[targetIndex + 1];
        }

        if (targetIndex >= 1) {
          prevMessageId = state.ids[targetIndex - 1];
        }
      }
    }

    return {
      ...state,
      state: EMessageState.VIEW,
      status: EMessageStateStatus.LOADING,
      current_message_id: id_message,
      prev_message_id: prevMessageId,
      next_message_id: nextMessageId,
    };
  }),
  on(viewMessageSuccess, (state, { messages, extraData, currentPage, hasMoreData }): IMessageState => {
    return {
      ...state,
      extraData,
      current_messages: messages,
      status: EMessageStateStatus.READY,
      currentPage,
      hasMoreData,
    };
  }),
  on(viewMessageError, (state, { error }) => {
    return {
      ...state,
      status: EMessageStateStatus.ERROR,
      error,
    };
  }),
  on(setSpam, state => {
    return {
      ...state,
      state: EMessageState.VIEW,
    };
  }),
  on(setSpamSuccess, (state, { messages }) => {
    return {
      ...state,
      current_messages: messages,
      status: EMessageStateStatus.READY,
    };
  }),

  on(setSpamError, (state, { error }) => {
    return {
      ...state,
      status: EMessageStateStatus.ERROR,
      error,
    };
  }),
  on(clearMessages, () => initalState),
);

export function reducer(state: IMessageState, action: Action) {
  return messagesReducer(state, action);
}
